export var CardType;
(function (CardType) {
    CardType["American"] = "American";
    CardType["Asian"] = "Asian";
    CardType["Multiview"] = "Multiview";
    CardType["Regular"] = "Regular";
})(CardType || (CardType = {}));
//# sourceMappingURL=CardTypes.js.map